import React from 'react';

import { Box, DropdownMenu } from '@betterment/samba-react';

import { ImpersonationLink, ImpersonationLinkProps } from './ImpersonationLink';

export const DropdownImpersonationLink: React.FC<ImpersonationLinkProps> = props => {
  return (
    <DropdownMenu.Item>
      <Box css={{ width: 'size.full' }}>
        <ImpersonationLink {...props} />
      </Box>
    </DropdownMenu.Item>
  );
};
